import { combineReducers } from "redux";
import common from "../features/common/Slice";

const commonOtp = combineReducers({
  common: common,
});

export default commonOtp;
